import React, { useEffect } from 'react'
import styled from 'styled-components'
import theme from '../../theme'
import i18n from '../../i18n'
import Sound from '../../assets/sound.svg'
import Icon from '../Icon'

declare const ReadSpeaker: any
declare const rspkr: any
declare global {
  interface Window {
    rsConf?: {
      general: any
      ui: any
      params?: any
    }
    readpage(href: string, id: string): any
  }
}

interface Props {
  align?: string
}

const Readspeaker: React.FC<Props> = ({ align }) => {
  useEffect(() => {
    if (typeof ReadSpeaker === 'undefined') {
      return
    }

    ReadSpeaker.q(function() {
      if (rspkr.ui.getActivePlayer()) {
        rspkr.ui.getActivePlayer().close()
      }
    })

    ReadSpeaker.init()
    ReadSpeaker.q(function() {
      rspkr.ui.addClickEvents()
    })
  }, [])

  function handleReadspeaker() {
    window.readpage(
      `https://app-eu.readspeaker.com/cgi-bin/rsent?customerid=6881&lang=nl_nl&readid=readspeakerArea&url=${encodeURIComponent(
        document.location.href
      )}`,
      'screenreader'
    )

    return false
  }

  return (
    <ReadSpeakerContainer>
      <ButtonContainer id="readspeaker_button" className="rs_skip readspeakerButton" $align={align}>
        <Button
          onClick={e => {
            if (typeof window.readpage !== 'function') {
              return
            }
            e.preventDefault()
            handleReadspeaker()
          }}
          rel="noopener"
          className="rsbtn_play"
          accessKey="L"
          title={i18n.t('readspeaker.buttonTitle')}
          role="button"
          href={`https://app-eu.readspeaker.com/cgi-bin/rsent?customerid=6881&lang=nl_nl&readid=readspeakerArea&url=${encodeURIComponent(
            document.location.href
          )}`}
        >
          <Icon icon={Sound} />
          {i18n.t('readspeaker.read')}
        </Button>
      </ButtonContainer>

      <PlayerContainer $align={align}>
        <div
          id="screenreader"
          className="rs_addtools rs_splitbutton rs_preserve rs_skip rs_exp"
        ></div>
      </PlayerContainer>
    </ReadSpeakerContainer>
  )
}

const ReadSpeakerContainer = styled.div`
  width: auto;
`

const ButtonContainer = styled.div<{ $align: string | undefined }>`
  text-align: ${({ $align }) => $align || 'center'};
  margin: 0 auto 1rem;

  ${({ $align }) =>
    $align === 'left' &&
    `
  margin: 0 0 1rem;
  `}
`

const Button = styled.a`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin: 0;
  padding: 9px 14px;
  font-size: 15px;
  color: ${theme.lightFontColor};
  border: 1px solid ${theme.lightGrey};
  border-radius: 4px;
  text-decoration: none;
  transition: none 0.3s ease;
  transition-property: background-color, color, border-color;

  &:hover {
    border-color: ${theme.blue};
    background-color: ${theme.blue};
    text-decoration: none;
    color: white;
  }

  svg {
    margin-right: 9px;
    height: 17px;
    width: 21px;
    vertical-align: middle;
  }
`

const PlayerContainer = styled.div<{ $align: string | undefined }>`
  width: 100%;
  display: flex;
  justify-content: center;

  ${({ $align }) =>
    $align === 'left' &&
    `
    justify-content: start;
  `}
`

export default Readspeaker
